<mat-form-field [hidden]="frmGroup.get(this.configData.name)['hidden']" fxFlex="0 0 100%" appearance="outline" class="dhl-borderless-field" [formGroup]="frmGroup" enctype="multipart/form-data" color="accent">
    <div>
        <input matInput [hidden]="true" type="text" autocomplete="off" type="text"/>
    </div>

    <div (click)="browse(configData)" *ngIf="configData.type === 'link/pdf'" class="download-content">
        <label class="main-label"><b>{{configData.label}}</b></label><br/>
        <img class="download-icon" src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,2400,16,20))">
    </div>

    <div *ngIf="configData.type !== 'link/pdf'">  
        <div *ngIf="configData.uploadVersion === 'v2'; else v1">
            <input #excelFile2 [hidden]="true" mat-flat-button color="primary" type="file" autocomplete="off" [formControlName]="configData.name" [placeholder]="configData.placeHolder"
            [required]="configData.required" (change)="handleFileInput($event.target.files)"  accept="{{configData.fileAccept}}" [multiple]="isMultipleUploadAllowed" />
            <button mat-button color="warn" [disabled]="!frmGroup.get(this.configData.name).enabled" (click)="excelFile2.click()">
                <mat-icon>cloud_upload</mat-icon>
                <span>&nbsp;&nbsp;&nbsp; {{configData.label}}</span>
				<span *ngIf="configData.required"> *</span>
            </button>
        </div>
        <ng-template #v1>
            <input #excelFile1 [hidden]="true" mat-flat-button color="primary" type="file" autocomplete="off" [formControlName]="configData.name" [placeholder]="configData.placeHolder"
        [required]="configData.required" (change)="handleFileInput($event.target.files)" [attr.accept]="fileAcceptType" [multiple]="isMultipleUploadAllowed" />
        <button *ngIf = "!configData.modal" mat-button color="warn" [disabled]="!frmGroup.get(this.configData.name).enabled" (click)="excelFile1.click()">
            <mat-icon>cloud_upload</mat-icon>
            <span>&nbsp;&nbsp;&nbsp; {{configData.label}}</span>			
            <span *ngIf="configData.required"> *</span>
        </button>
        <button type="button" *ngIf = "configData.modal" mat-button color="warn" [disabled]="!frmGroup.get(this.configData.name).enabled" (click)="modalOnClick(configData.modal, configData)">
       
            <mat-icon>cloud_upload</mat-icon>
            <span>&nbsp;&nbsp;&nbsp; {{configData.label}}</span>
        </button>
        </ng-template>

 
        <span *ngIf="isMultipleUploadAllowed && this.filesToUpload.length && this.showFileName" class="selected-file-name-label">
            {{filesToUpload.length}} file(s) selected
        </span>
        <span *ngIf="!isMultipleUploadAllowed && this.fileToUpload && this.showFileName" class="selected-file-name-label">
            {{this.fileToUpload['name']}}
        </span>
        <!-- View Order File Name Show -->
        <span *ngIf="this.fileToUploadForView && this.showFileName && !this.fileToUpload" class="selected-file-name-label">
            {{this.fileToUploadForView}}
        </span>
        <span style="color:green" *ngIf="uploadMsg">{{uploadMsg}}</span>
        <!-- <button mat-flat-button color="primary" (click)="excelFile.click()">Choose Excel File (XLSX)</button> -->

    </div>
    <mat-error *ngIf="frmGroup.get(configData.name).errors">
        <mat-error *ngIf="frmGroup.get(configData.name).errors.required">            
            Required            
        </mat-error>         
    </mat-error>
</mat-form-field>

<!-- <button (click)="fileInput.click()">
    <mat-icon>library_add</mat-icon>
    <span>Select</span>
    <input #fileInput type="file" (change)="onFileInput($event)" style="display:none;" />
  </button> -->


  <!-- <form enctype="multipart/form-data">
    <input type="file" id="myfile" name="myfile"><br><br>
  </form> -->
